import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appImgLazyLoad]',
})
export class ImgLazyLoadDirective {
  constructor({nativeElement}: ElementRef<HTMLImageElement>) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
  }
}
